import { Modal, Form, Button } from "react-bootstrap";
import { useState } from "react";

const InsertImageModal = ({ show, handleClose }) => {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState("");
  const [url, setUrl] = useState("");

  // Handle File Upload
  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    if (selected) {
      setFile(selected);
      setPreview(URL.createObjectURL(selected));
      setUrl("");
    }
  };

  // Handle URL Input
  const handleUrlChange = (e) => {
    setUrl(e.target.value);
    setPreview(e.target.value);
    setFile(null);
  };

  const handleInsert = () => {
    console.log("Selected Image:", file || url);
    handleClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      backdrop="static"
      keyboard={false}
      className="insert-modal"
    >
      {/* HEADER */}
      <Modal.Header closeButton>
        <Modal.Title>Insert Image</Modal.Title>
      </Modal.Header>

      {/* BODY */}
      <Modal.Body>

        {/* FILE INPUT */}
        <Form.Group>
          <Form.Label>Select from files</Form.Label>

          <div className="file-box">
            <input type="file" onChange={handleFileChange} />
          </div>
        </Form.Group>

        {/* URL INPUT */}
        <Form.Group className="mt-3">
          <Form.Label>Image URL</Form.Label>
          <Form.Control
            value={url}
            onChange={handleUrlChange}
            placeholder=""
          />
        </Form.Group>

        {/* PREVIEW */}
        {preview && (
          <div className="preview-box">
            <img src={preview} alt="preview" />
          </div>
        )}

      </Modal.Body>

      {/* FOOTER */}
      <div className="modal-footer-custom">
        <Button className="btn-orange" onClick={handleInsert}>
          Insert Image
        </Button>
      </div>

      {/* STYLES */}
      <style>{`

        /* MODAL */
        .insert-modal .modal-content {
          border-radius: 8px;
        }

        .insert-modal .modal-header {
          border-bottom: 1px solid #eee;
          padding: 12px 18px;
        }

        .insert-modal .modal-title {
          font-size: 16px;
          font-weight: 600;
        }

        .insert-modal .modal-body {
          padding: 18px;
        }

        /* LABEL */
        .insert-modal .form-label {
          font-size: 13px;
          margin-bottom: 6px;
        }

        /* FILE BOX */
        .file-box {
          border: 1px solid #ddd;
          padding: 8px;
          border-radius: 4px;
          background: #fff;
        }

        .file-box input {
          border: none;
          width: 100%;
        }

        /* INPUT */
        .insert-modal .form-control {
          height: 36px;
          font-size: 13px;
        }

        /* PREVIEW */
        .preview-box {
          margin-top: 15px;
          text-align: center;
        }

        .preview-box img {
          max-width: 100%;
          max-height: 150px;
          border-radius: 6px;
          border: 1px solid #ddd;
        }

        /* FOOTER */
        .modal-footer-custom {
          padding: 12px 18px;
          border-top: 1px solid #eee;
          display: flex;
          justify-content: flex-end;
        }

        /* BUTTON */
        .btn-orange {
          background: #ff6b2c;
          border: none;
          color: white;
          padding: 6px 14px;
          font-size: 13px;
        }

        /* MOBILE */
        @media(max-width:768px){
          .modal-footer-custom {
            justify-content: center;
          }
        }

      `}</style>
    </Modal>
  );
};

export default InsertImageModal;